import { useState, createContext, useEffect } from 'react';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import apiKeycloak from '../api/apiKeycloak';
import api from '../api/api';
import queryString from 'querystring';
import jwt from 'jwt-decode';
// import { campanhaService } from '../services/campanhaService';

export const AuthContext = createContext({});

function AuthProvider({ children }) {

  const [user, setUser] = useState(null);
  const [permissoes, setPermissoes] = useState(() => {
    const storedPermissoes = localStorage.getItem('permissoes');
    return storedPermissoes ? JSON.parse(storedPermissoes) : []
  });
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [periodoInscricoesAtivo, setPeriodoInscricoesAtivo] = useState(false);
  const [loadingPeriodo, setLoadingPeriodo] = useState(true);
  //   const [campanhaAtiva, setCampanhaAtiva] = useState(null);

  async function loadPermissions(grupo) {    

    const response = await api.get(`grupoPermissoes/getByNome/${grupo}`);
    let permissoes = {};    

    if (response?.data && response?.data?.permissoes?.length > 0) {
      for (const permission of response.data.permissoes) {
        // Use the `rotaNome` as the key and the rest of the object as the value
        permissoes[permission.rotaNome] = {
          id: permission.id,
          criar: permission.criar,
          deletar: permission.deletar,
          editar: permission.editar,
          visualizar: permission.visualizar,
          rotaId: permission.rotaId
        };
      }
    }

    return permissoes;
  }

  //Fazendo login do usuario
  async function signIn(email, password) {
    setLoadingAuth(true);

    // Faz login no Keycloak
    const data = await auth_keycloak(email, password);

    if (data !== null) {
      

      // Pega a primeira role que começa com "user-"
      const roleFull = data.perfilUser.find(r => r.startsWith("user-"));
      const role = roleFull?.replace("user-", ""); // "admin"


      if (role) {
        // Carrega as permissões do back enviando a role
        const response = await loadPermissions(role);

        if (response) {
          setPermissoes(response);
          localStorage.setItem("permissoes", JSON.stringify(response));
        }
      }

      // Define rota padrão
      localStorage.setItem('route', '/admin');

      setUser(data);
    }

    setLoadingAuth(false);
    return data;
  }


  // const fetchPeriodoStatus = async () => {
  //   setLoadingPeriodo(true);
  //   try {
  //     const response = await api.get('/periodoMatricula/periodo');
  //     if (response.data && typeof response.data.periodoInscricoes === 'boolean') {
  //       setPeriodoInscricoesAtivo(response.data.periodoInscricoes);
  //     } else {
  //       console.error("Resposta inesperada da API /periodoMatricula/periodo:", response.data);
  //       setPeriodoInscricoesAtivo(false);
  //     }
  //   } catch (error) {
  //     console.error("Erro ao buscar status do período de inscrição:", error);
  //     setPeriodoInscricoesAtivo(false);
  //   } finally {
  //     setLoadingPeriodo(false);
  //   }
  // };

  useEffect(() => {
    let isMounted = true;

    const fetchPeriodoStatus = async () => {
      setLoadingPeriodo(true);

      try {
        const response = await api.get('/periodoMatricula/periodo');

        if (isMounted) {
          if (response.data && typeof response.data.periodoInscricoes === 'boolean') {
            setPeriodoInscricoesAtivo(response.data.periodoInscricoes);
          } else {
            console.error("Resposta inesperada:", response.data);
            setPeriodoInscricoesAtivo(false);
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error("Erro ao buscar status do período:", error);
          setPeriodoInscricoesAtivo(false);
        }
      } finally {
        if (isMounted) {
          setLoadingPeriodo(false);
        }
      }
    };

    fetchPeriodoStatus();

    return () => {
      isMounted = false;
    };
  }, []);

  async function auth_keycloak(email, password) {

    let dataResponse = null;
    let tokenTemp = null;

    // Form de dados para obtenção do acess token
    //OBS: IMPLEMENTAR O CÓDIGO ABAIXO EM UMA FUNÇÃO...
    const form = {
      "client_id": process.env.REACT_APP_API_KEYCLOAK_CLIENT_ID,
      "username": email,
      "password": password,
      "grant_type": "password",
      "client_secret": process.env.REACT_APP_API_KEYCLOAK_CLIENT_SECRET,
      "scope": "openid"
    };

    // OBtendo o access token do cliente keycloak
    await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_TOKEN_CLIENT, queryString.stringify(form),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then((res) => {
        tokenTemp = res.data;
      })
      .catch((error) => {
        console.log(error + " DEU RUIM ao obter o token............")
        return error;
      });

    //Obtendo as informações do usuário do keycloak caso o token seja válido... 
    if (tokenTemp !== null) {
      await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_USERINFO,
        {}, {
        headers: { "Authorization": `Bearer ${tokenTemp.access_token}` }
      })
        .then((response) => {
          dataResponse = {
            uid: response.data.sub,
            nome: response.data.name,
            avatarUrl: response.data.avatarUrl,
            email: response.data.email,
            tokenInfo: tokenTemp,
            perfilUser: jwt(tokenTemp.access_token).realm_access.roles,
          }
        })
        .catch((error) => {
          console.log(error.error + " DEU RUIM............")
          return error;
        });
    }

    return dataResponse;
  }

  async function updatePasswordUser(email, password) {
    console.log('entrei');
    setLoadingAuth(false);
    setLoading(false);

    // const getToken = await get_AccessToken(email, password);

    let tokenTemp = null;

    // Form de dados para obtenção do token admin-cli
    //OBS: IMPLEMENTAR O CÓDIGO ABAIXO EM UMA FUNÇÃO...
    const form = {
      "client_id": "admin-cli",
      "grant_type": "client_credentials",
      "client_secret": process.env.REACT_APP_API_KEYCLOAK_ADMIN_SECRET,
      "scope": "openid"
    };

    // OBtendo o access token do master keycloak
    await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_TOKEN_MASTER, queryString.stringify(form),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then((res) => {
        tokenTemp = res.data;
      })
      .catch((error) => {
        console.log(error + " DEU RUIM ao obter o token............")
      });

    //Criando usuário usando o token admin-cli obtido
    let credencias = [{
      'type': 'password',
      'value': password,
      'temporary': false

    }];
    // const dadosUsuario = {
    //   "username": email,
    //   "firstName": resultadoNome[0],
    //   "lastName": nome.replace(resultadoNome[0], ""),
    //   "email": email,
    //   "enabled": "true",
    //   "credentials": credencias
    // };

    const dadosUsuario = { type: "password", value: password, temporary: false }

    const urlGetId = `https://auth.patosdeminas.mg.gov.br/admin/realms/conservatorio/users?email=${email}`;

    const userId = await apiKeycloak.get(urlGetId,
      {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${tokenTemp.access_token}` }
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log("Deu ruim " + error)
        return error.response
      })

    console.log(userId);

    // Teste com nova abordagem
    const updatePasswordEndpoint = `https://auth.patosdeminas.mg.gov.br/admin/realms/conservatorio/users/${userId.data[0].id}/reset-password`;

    return await apiKeycloak.put(updatePasswordEndpoint, dadosUsuario,
      {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${tokenTemp.access_token}` }
      })
      .then((response) => {
        console.log("Sucesso - alterada a senha do usuário")
        return response
      })
      .catch((error) => {
        console.log("Deu ruim " + error)
        return error.response
      })

  }


  async function updatePasswordUserPerfil(email, password) {
    setLoading(false);

    let tokenTemp = null;

    const form = {
      client_id: "admin-cli",
      grant_type: "client_credentials",
      client_secret: process.env.REACT_APP_API_KEYCLOAK_ADMIN_SECRET
    };

    try {
      // Obtem o access token
      const tokenRes = await apiKeycloak.post(
        process.env.REACT_APP_API_KEYCLOAK_TOKEN_MASTER,
        queryString.stringify(form),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      );

      tokenTemp = tokenRes.data;

      const urlGetId = `https://auth.patosdeminas.mg.gov.br/admin/realms/conservatorio/users?email=${email.trim()}`;

      const userIdRes = await apiKeycloak.get(urlGetId, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenTemp.access_token}`
        }
      });

      if (!userIdRes || !userIdRes.data || userIdRes.data.length === 0) {
        throw new Error("Usuário não encontrado.");
      }

      const userId = userIdRes.data[0].id;

      const updatePasswordEndpoint = `https://auth.patosdeminas.mg.gov.br/admin/realms/conservatorio/users/${userId}/reset-password`;

      const dadosUsuario = {
        type: "password",
        value: password,
        temporary: false
      };

      const updateRes = await apiKeycloak.put(updatePasswordEndpoint, dadosUsuario, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenTemp.access_token}`
        }
      });

      return updateRes;
    } catch (error) {
      console.error("Erro ao atualizar senha:", error.response?.data || error.message);
      return error.response;
    }
  }


  //Cadastrando um novo usuario
  async function signUp(email, password, nome) {
    try {
      setLoadingAuth(true);  // Set loading state to true during the process

      let tokenTemp = null;
      let resultadoNome = nome.split(" ");

      // Form for admin token request
      const form = {
        "client_id": "admin-cli",
        "grant_type": "client_credentials",
        "client_secret": process.env.REACT_APP_API_KEYCLOAK_ADMIN_SECRET,
        "scope": "openid"
      };

      // Get access token for admin
      const tokenResponse = await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_TOKEN_MASTER, queryString.stringify(form), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });

      tokenTemp = tokenResponse.data.access_token;

      // Define user credentials and user data
      const credentials = [{
        type: 'password',
        value: password,
        temporary: false
      }];
      const userData = {
        username: email,
        firstName: resultadoNome[0],
        lastName: nome.replace(resultadoNome[0], "").trim(),
        email: email,
        enabled: true,
        credentials: credentials
      };

      // Create user using the obtained admin token
      await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_USERS, userData, {
        headers: {
          Authorization: `Bearer ${tokenTemp}`,
          "Content-Type": "application/json"
        }
      });

      console.log("User successfully created");
    } catch (error) {
      console.error("Error creating user:", error);
    } finally {
      setLoadingAuth(false);
    }
  }




  //Logout do usuario
  async function signOut() {
    //Obtendo as informações do usuário do keycloak  
    const form = {
      "client_id": process.env.REACT_APP_API_KEYCLOAK_CLIENT_ID,
      "client_secret": process.env.REACT_APP_API_KEYCLOAK_CLIENT_SECRET,
      "refresh_token": user.tokenInfo.refresh_token
    };
    try {
      await verificaToken(user);
      await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_LOGOUT, queryString.stringify(form),
        {
          headers: { "Authorization": `Bearer ${user.tokenInfo.access_token}` }
        })
        .then((response) => {
          localStorage.removeItem('user');
          localStorage.removeItem('permissoes');
          localStorage.removeItem('route');
          setUser(null);
          setPermissoes(null);
        })

    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('permissoes');
      localStorage.removeItem('route');
      setUser(null);
      console.log(error + " DEU RUIM AO SAIR...........")
    }
  }


  //Verifica se o token é valido...
  async function verificaToken(userStorage) {

    const agora = (Date.now() / 1000).toFixed(0);
    const exp = jwt(userStorage.tokenInfo.access_token).exp;
    const tempUser = userStorage;

    // Verifica validade do token...
    if (agora > exp - 10) {

      const form = {
        "client_id": process.env.REACT_APP_API_KEYCLOAK_CLIENT_ID,
        "grant_type": "refresh_token",
        "client_secret": process.env.REACT_APP_API_KEYCLOAK_CLIENT_SECRET,
        "refresh_token": tempUser.tokenInfo.refresh_token
      };

      // OBtendo novo access token do cliente keycloak
      await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_TOKEN_CLIENT, queryString.stringify(form),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then((res) => {

          tempUser.tokenInfo = res.data;
          setUser(tempUser);
        })
        .catch((error) => {
          setUser(null);

        });
    } else {
      setUser(tempUser);
    }
  }

  //Resertar senha via email....
  async function resetPassword(email) {
    setLoadingAuth(true);
    let tokenTemp = null;
    let userTemp = null;

    // Form de dados para obtenção do token admin-cli    
    const form = {
      "client_id": "admin-cli",
      "grant_type": "client_credentials",
      "client_secret": process.env.REACT_APP_API_KEYCLOAK_ADMIN_SECRET,
      "scope": "openid"
    };

    // OBtendo o access token do cliente keycloak
    await apiKeycloak.post(process.env.REACT_APP_API_KEYCLOAK_TOKEN_MASTER, queryString.stringify(form),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then((response) => {
        tokenTemp = response.data;
      })
      .catch((error) => {
        console.log(error + " DEU RUIM ao obter o token............")
      });

    //fazendo a chamada api  para obtenção do usuário de acordo com o email

    await apiKeycloak.get(process.env.REACT_APP_API_KEYCLOAK_USERS + '?email=' + email,
      { headers: { "Authorization": `Bearer ${tokenTemp.access_token}` } },
    )
      .then((response) => {
        userTemp = response.data;
      })
      .catch((error) => {
        console.log(error.error + " DEU RUIM AO OBTER USUÁRIO............")
      });

    // Fazendo a chamada api para disparo do envio de email para reset da senha
    //Verifica se houve retorno de um usuário
    if (userTemp.length === 1) {
      return await apiKeycloak.put(process.env.REACT_APP_API_KEYCLOAK_USERS + userTemp[0].id + '/execute-actions-email', '["UPDATE_PASSWORD"]',
        {
          headers: { "Content-Type": "application/json", "Authorization": `Bearer ${tokenTemp.access_token}` }
        })
        .then((response) => {
          setLoadingAuth(false);
          return response
        })
        .catch((error) => {
          setLoadingAuth(false);
          return error.response
        });
    } else {
      setLoadingAuth(false);
      return { status: 409 }
    }

  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        loading,
        // campanhaAtiva,
        signUp,
        signOut,
        signIn,
        loadingAuth,
        setUser,
        setPermissoes,
        permissoes,
        verificaToken,
        resetPassword,
        updatePasswordUser,
        updatePasswordUserPerfil,
        loadPermissions,
        periodoInscricoesAtivo,
        loadingPeriodo
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider;
